import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { CookingInventoryDto } from "./cooking-inventory.dto";

export class CookingInventoryResponse extends GlobalResponseObject {
    data?: CookingInventoryDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CookingInventoryDto[]) {
        super(status, intlCode, internalMessage)
        this.data = data;
    }
}